import { api, RequestOptions } from '@/api/api';
import {
  AlbumUpload,
  AlbumUploadCommitPayload,
  TrackFileMeta
} from '@/types/albumUpload';

export const AlbumUploadService = {
  createDraft(): Promise<{ id: number }> {
    return api.post('/album-upload');
  },

  getList(): Promise<AlbumUpload[]> {
    return api.get('/album-upload');
  },

  getOne(id: number): Promise<AlbumUpload> {
    return api.get(`/album-upload/${id}`);
  },

  uploadTrackFile(id: number, file: File, opts?: RequestOptions): Promise<TrackFileMeta> {
    const formData = new FormData();
    formData.set('file', file);

    return api.post(`/album-upload/${id}/track`, formData, opts);
  },

  uploadCover(id: number, file: File): Promise<{ status: string }> {
    const formData = new FormData();
    formData.set('cover', file);

    return api.post(`/album-upload/${id}/cover`, formData);
  },

  deleteTrackFile(id: number, trackUploadId: number): Promise<{ status: string }> {
    return api.delete(`/album-upload/${id}/track/${trackUploadId}`);
  },

  commit(id: number, payload: AlbumUploadCommitPayload): Promise<{ status: string }> {
    return api.post(`/album-upload/${id}/commit`, payload);
  },

  retry(id: number): Promise<{ status: string }> {
    return api.post(`/album-upload/${id}/retry`);
  },

  remove(id: number): Promise<{ status: string }> {
    return api.delete(`/album-upload/${id}`);
  }
};
